import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"row mb-5\"><div class=\"col-12 text-center\"><div class=\"bf-heading-script text-primary\">Kursplan</div></div></div><div class=\"row mb-4\"><div class=\"col-12 col-lg-4\"><div class=\"d-flex mb-3\"><div class=\"pe-3\"><div class=\"bf-course-type-circle\" style=\"background:#D40250;\"></div></div><div class=\"flex-grow-1\"><div class=\"bf-heading-script\">Offene Kurse</div><div style=\"line-height:1.4;\"> Fortlaufend.<br> Einstieg jederzeit möglich! </div></div></div></div><div class=\"col-12 col-lg-4\"><div class=\"d-flex mb-3\"><div class=\"pe-3\"><div class=\"bf-course-type-circle\" style=\"background:#A9C917;\"></div></div><div class=\"flex-grow-1\"><div class=\"bf-heading-script\">Geschlossene Kurse</div><div style=\"line-height:1.4;\"> 80% Rückerstattung von Krankenkassen!<br> Einstieg nur zum Kursstart möglich! </div></div></div></div><div class=\"col-12 col-lg-4\"><div class=\"d-flex mb-3\"><div class=\"pe-3\"><div class=\"bf-course-type-circle\" style=\"background:#F2B51F;\"></div></div><div class=\"flex-grow-1\"><div class=\"bf-heading-script\">Geschlossene Kurse</div><div style=\"line-height:1.4;\"> Keine Rückerstattung von Krankenkassen.<br> Einstieg nur zum Kursstart möglich! </div></div></div></div></div>", 2)
const _hoisted_3 = { class: "bf-courses-week" }
const _hoisted_4 = { class: "bf-courses-week__tabs-container row" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "bf-courses-week__tab-label" }
const _hoisted_7 = { class: "bf-courses-week__content-container row bf-bg-gray" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = {
  key: 0,
  class: "bf-courses-week__content px-3 px-md-5 py-3"
}
const _hoisted_10 = {
  key: 0,
  class: "my-5 text-center"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "my-5 text-center"
}
const _hoisted_14 = { class: "row bf-courses-week__content-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseFilter = _resolveComponent("CourseFilter")!
  const _component_RegionCoursesCard = _resolveComponent("RegionCoursesCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_CourseFilter, {
      locations: _ctx.filterLocations,
      "course-types": _ctx.filterCourseTypes,
      "current-course-count": _ctx.courses.length,
      class: "pb-md-2 mb-4"
    }, null, 8, ["locations", "course-types", "current-course-count"]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.days, (day, index) => {
          return (_openBlock(), _createElementBlock("a", {
            key: index,
            class: _normalizeClass(["bf-courses-week__tab col", {'bf-courses-week__tab--active': index === _ctx.dayCurrent, 'bf-courses-week__tab--empty': _ctx.coursesByWeekday?.[index].length < 1}]),
            onClick: _withModifiers(($event: any) => (_ctx.setActiveTab(index)), ["prevent"]),
            href: "#"
          }, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(day), 1)
          ], 10, _hoisted_5))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.coursesByWeekday, (weekday, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
              (index === _ctx.dayCurrent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    (_ctx.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
                      : (weekday.length < 1)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_13, "Aktuell wird an diesem Tag leider kein Kurs angeboten."))
                        : _createCommentVNode("", true),
                    _withDirectives(_createElementVNode("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(weekday, (course) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: course.id,
                          class: "col-12 col-sm-6 col-lg-4 col-xl-3 bf-courses-week__course-column"
                        }, [
                          _createVNode(_component_RegionCoursesCard, {
                            course: course,
                            "user-course-enrollments": _ctx.userCourseEnrollments,
                            "loading-enrollments": _ctx.loadingEnrollments
                          }, null, 8, ["course", "user-course-enrollments", "loading-enrollments"])
                        ]))
                      }), 128))
                    ], 512), [
                      [_vShow, !_ctx.loading && weekday.length > 0]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ])
      ])
    ])
  ], 64))
}